module.exports = __webpack_public_path__ + "static/img/report3d_combination01.4460dc66.png";